<template>
  <el-tooltip
    effect="dark"
    :content="content"
    :placement="placement ? placement : 'top'"
    ><i class="el-icon-info"></i
  ></el-tooltip>
</template>

<script>
export default {
  props: ["content", "placement"],
};
</script>


// WEBPACK FOOTER //
// src/components/tips/Tips.vue